import rehypeSlug from 'rehype-slug'
import rehypeRaw from 'rehype-raw'
import ReactMarkdown from 'react-markdown'
import { PropsWithChildren } from 'react'
import { TbArrowRight } from 'react-icons/tb'
import { Heading, Text } from 'ui-kit/typography'
import { IntegrationType } from 'routes/Integrations/helpers/types'
import { LINKS } from 'routes/constants'
import NavLink from 'ui-kit/actions/link/NavLink'
import classes from './IntegrationPageGettingStarted.module.scss'

const rehypePlugins = [rehypeSlug, rehypeRaw]

const getMarkdownComponents = (link: string) => {
  return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].reduce(
    (acc, key) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
      acc[key] = ({ node, level, id, ...props }: any) => {
        return <HeaderNavComponent {...props} link={`${link}#${id}`} />
      }
      return acc
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {} as Record<string, any>,
  )
}

export function IntegrationPageGettingStarted({
  integration,
  gettingStartedToc,
}: {
  integration: IntegrationType
  gettingStartedToc?: string
}) {
  if (!gettingStartedToc) {
    return null
  }

  const gettingStartedPageLink = `${LINKS.INTEGRATIONS}/${integration.key}/getting-started`

  return (
    <section className={classes.section}>
      <div className={classes.faq}>
        <Heading as={'h3'}>Getting Started</Heading>
        <ul className={classes.faq__list}>
          <NavComponent link={gettingStartedPageLink}>
            Getting Started with {integration.name} API
          </NavComponent>

          <ReactMarkdown
            rehypePlugins={rehypePlugins}
            components={getMarkdownComponents(gettingStartedPageLink)}
          >
            {gettingStartedToc}
          </ReactMarkdown>
        </ul>
      </div>
    </section>
  )
}

function HeaderNavComponent({
  children,
  link,
}: PropsWithChildren<{ link: string }>) {
  return <NavComponent link={link}>{children}</NavComponent>
}

function NavComponent({ children, link }: PropsWithChildren<{ link: string }>) {
  return (
    <li className={classes.faq__item}>
      <NavLink className={classes.faq__link} href={link}>
        <Text as={'span'} className={classes.faq__text}>
          {children}
        </Text>
        <TbArrowRight className={classes.faq__icon} />
      </NavLink>
    </li>
  )
}
